import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import Button from './Button';

const messages = defineMessages({
  Yes: 'Yes',
  No: 'No',
  Cancel: 'Cancel',
});

class YesNoCancelModal extends Component {
  static propTypes = {
    title: PropTypes.node,
    show: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    onYes: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    message: PropTypes.node,
  };

  render() {
    const { title, show, onCancel, onNo, onYes, disabled, intl, message } = this.props;

    return (
      <Modal show={show} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{message}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCancel}>
            {intl.formatMessage(messages.Cancel)}
          </Button>
          <Button showProgress onClick={onNo}>
            {intl.formatMessage(messages.No)}
          </Button>
          <Button
            onClick={onYes}
            disabled={disabled}
            btnClassName="btn-inverse"
            showProgress
          >
            {intl.formatMessage(messages.Yes)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(YesNoCancelModal);
